import React from 'react';
import { NestedRouter } from 'src/router';
import { routes } from './routes';

function SolutionJobs() {
  return <NestedRouter routes={routes} />;
}

export default SolutionJobs;
